import React, { useState } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';

const ContactPage = () => {
  // Form state
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    serviceType: 'Residential Services',
    message: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsSuccess(false);

    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setForm({
        fullName: '',
        email: '',
        phone: '',
        serviceType: 'Residential Services',
        message: '',
      });
      // Reset success message after 3 seconds
      setTimeout(() => setIsSuccess(false), 3000);
    }, 1500);
  };

  // Newsletter state (minimal)
  const [newsletterEmail, setNewsletterEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (newsletterEmail.trim()) {
      // Handle newsletter signup
      console.log('Newsletter email:', newsletterEmail);
      setNewsletterEmail('');
      alert('Thank you for subscribing!');
    }
  };

  return (
    <div className="bg-background pt-14 text-on-surface font-body-md selection:bg-primary-fixed selection:text-on-primary-fixed">
      <Header />

      <main>
        {/* Hero Section */}
        <section className="relative pt-16 pb-12 overflow-hidden">
          <div className="max-w-container-max mx-auto px-gutter relative z-10 text-center">
            <h1 className="font-headline-xl text-headline-lg-mobile md:text-headline-xl text-primary mb-4">
              Get in Touch
            </h1>
            <p className="font-body-lg text-on-surface-variant max-w-2xl mx-auto">
              Whether you're in an emergency or looking to secure your property, our professional team is ready to assist 24/7 across the USA.
            </p>
          </div>
        </section>

        {/* Main Interaction Area */}
        <section className="max-w-container-max mx-auto px-gutter pb-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-gutter">
            {/* Contact Form Card */}
            <div className="lg:col-span-7 bg-surface-container-lowest glass-card rounded-xl p-8 md:p-12 shadow-[0px_10px_40px_rgba(0,11,40,0.03)]">
              <h2 className="font-headline-md text-primary mb-8">General Inquiry</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Full Name */}
                  <div className="space-y-2">
                    <label className="font-label-md text-on-surface-variant peer-focus-within:text-primary peer-focus-within:font-bold transition-colors" htmlFor="fullName">
                      Full Name
                    </label>
                    <input
                      id="fullName"
                      name="fullName"
                      value={form.fullName}
                      onChange={handleChange}
                      className="w-full bg-surface-container-low border border-outline-variant/30 rounded-lg h-14 px-4 peer focus:ring-2 focus:ring-primary focus:border-primary transition-all"
                      placeholder="John Doe"
                      type="text"
                      required
                    />
                  </div>
                  {/* Email */}
                  <div className="space-y-2">
                    <label className="font-label-md text-on-surface-variant peer-focus-within:text-primary peer-focus-within:font-bold transition-colors" htmlFor="email">
                      Email Address
                    </label>
                    <input
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      className="w-full bg-surface-container-low border border-outline-variant/30 rounded-lg h-14 px-4 peer focus:ring-2 focus:ring-primary focus:border-primary transition-all"
                      placeholder="john@example.com"
                      type="email"
                      required
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Phone */}
                  <div className="space-y-2">
                    <label className="font-label-md text-on-surface-variant peer-focus-within:text-primary peer-focus-within:font-bold transition-colors" htmlFor="phone">
                      Phone Number
                    </label>
                    <input
                      id="phone"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      className="w-full bg-surface-container-low border border-outline-variant/30 rounded-lg h-14 px-4 peer focus:ring-2 focus:ring-primary focus:border-primary transition-all"
                      placeholder="+1 (555) 000-0000"
                      type="tel"
                    />
                  </div>
                  {/* Service Type */}
                  <div className="space-y-2">
                    <label className="font-label-md text-on-surface-variant peer-focus-within:text-primary peer-focus-within:font-bold transition-colors" htmlFor="serviceType">
                      Service Type
                    </label>
                    <select
                      id="serviceType"
                      name="serviceType"
                      value={form.serviceType}
                      onChange={handleChange}
                      className="w-full bg-surface-container-low border border-outline-variant/30 rounded-lg h-14 px-4 peer focus:ring-2 focus:ring-primary focus:border-primary transition-all"
                    >
                      <option>Residential Services</option>
                      <option>Commercial Security</option>
                      <option>Emergency Lockout</option>
                      <option>Automotive</option>
                    </select>
                  </div>
                </div>
                {/* Message */}
                <div className="space-y-2">
                  <label className="font-label-md text-on-surface-variant peer-focus-within:text-primary peer-focus-within:font-bold transition-colors" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    className="w-full bg-surface-container-low border border-outline-variant/30 rounded-lg p-4 peer focus:ring-2 focus:ring-primary focus:border-primary transition-all"
                    placeholder="How can we help you today?"
                    rows="4"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full md:w-auto px-10 h-14 font-label-md rounded-lg hover:shadow-lg active:scale-[0.98] transition-all flex items-center justify-center gap-2 ${isSuccess
                    ? 'bg-green-600 text-white'
                    : 'bg-primary text-white'
                    } ${isSubmitting ? 'opacity-70 pointer-events-none' : ''}`}
                >
                  {isSubmitting && (
                    <span className="material-symbols-outlined text-[20px] animate-spin">sync</span>
                  )}
                  {isSuccess && (
                    <span className="material-symbols-outlined text-[20px]">check_circle</span>
                  )}
                  {isSubmitting ? 'Sending...' : isSuccess ? 'Message Sent!' : 'Send Message'}
                </button>
              </form>
            </div>

            {/* Contact Details Sidebar */}
            <div className="lg:col-span-5 space-y-gutter">
              {/* Emergency Hotline Card */}
              <div className="bg-primary-container text-white rounded-xl p-8 md:p-10 emergency-glow relative overflow-hidden group">
                <div className="absolute -right-8 -top-8 opacity-5 group-hover:scale-110 transition-transform duration-700">
                  <span className="material-symbols-outlined text-[160px]">shield_lock</span>
                </div>
                <div className="relative z-10">
                  <div className="flex items-center gap-2 text-secondary-container mb-2">
                    <span
                      className="material-symbols-outlined text-[20px]"
                      style={{ fontVariationSettings: '"FILL" 1' }}
                    >
                      verified
                    </span>
                    <span className="font-label-md uppercase tracking-wider">Available 24/7/365</span>
                  </div>
                  <h3 className="font-headline-md mb-4 text-white">Emergency Hotline</h3>
                  <p className="font-body-md text-white/80 mb-8 max-w-xs">
                    Our response team is stationed nationwide for 15-minute arrival times.
                  </p>
                  <a
                    className="inline-flex items-center gap-3 bg-secondary text-white px-8 py-4 rounded-full font-headline-md hover:bg-secondary/90 transition-colors shadow-lg"
                    href="tel:1800LOCKUSA"
                  >
                    <span className="material-symbols-outlined">call</span>
                    1-800-LOCK-USA
                  </a>
                </div>
              </div>

              {/* Info Cards Grid */}
              <div className="grid grid-cols-1 gap-4">
                <div className="bg-surface-container-lowest glass-card rounded-xl p-6 flex items-start gap-6 border-l-4 border-l-primary">
                  <div className="w-12 h-12 bg-primary-fixed rounded-lg flex items-center justify-center text-primary">
                    <span className="material-symbols-outlined">mail</span>
                  </div>
                  <div>
                    <h4 className="font-headline-md text-[18px] text-primary">Support Email</h4>
                    <p className="text-on-surface-variant font-body-md">support@thelocksmithusa.com</p>
                    <p className="text-on-surface-variant font-body-md">billing@thelocksmithusa.com</p>
                  </div>
                </div>
                <div className="bg-surface-container-lowest glass-card rounded-xl p-6 flex items-start gap-6 border-l-4 border-l-secondary">
                  <div className="w-12 h-12 bg-secondary-fixed rounded-lg flex items-center justify-center text-secondary">
                    <span className="material-symbols-outlined">location_on</span>
                  </div>
                  <div>
                    <h4 className="font-headline-md text-[18px] text-primary">Headquarters</h4>
                    <p className="text-on-surface-variant font-body-md">1776 Independence Ave, Ste 400</p>
                    <p className="text-on-surface-variant font-body-md">Washington, D.C. 20001</p>
                  </div>
                </div>
              </div>

              {/* FAQ Redirect Card */}
              <div className="bg-surface-container-highest rounded-xl p-8 border border-outline-variant/30 flex flex-col justify-between min-h-[220px] relative overflow-hidden group/faq shadow-sm hover:shadow-md transition-all duration-300">
                <div className="absolute -right-4 -bottom-4 opacity-10 group-hover/faq:scale-110 transition-transform duration-700 pointer-events-none">
                  <span className="material-symbols-outlined text-[120px]">help</span>
                </div>
                <div className="relative z-10">
                  <h3 className="font-headline-md text-primary mb-2 leading-tight">Need a quick answer?</h3>
                  <p className="text-on-surface-variant font-body-md leading-relaxed max-w-[300px]">
                    Browse our most frequently asked questions about security services and nationwide coverage.
                  </p>
                </div>
                <div className="relative z-10 mt-6">
                  <a
                    className="inline-flex items-center gap-2 bg-primary text-white px-6 py-3 rounded-lg font-label-md hover:bg-primary-container transition-all active:scale-95 group/btn"
                    href="#faq"
                  >
                    Go to FAQ
                    <span className="material-symbols-outlined text-[20px] group-hover/btn:translate-x-1 transition-transform">
                      arrow_forward
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="max-w-container-max mx-auto px-gutter mb-20">
          <div className="h-96 w-full rounded-xl overflow-hidden relative shadow-inner border border-outline-variant/30">
            <img
              className="w-full h-full object-cover grayscale contrast-125"
              alt="A clean professional map of the USA with red and navy highlights."
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuCds6PPNqPDDIXnZ2FuRx5EoNrfgmanVd-Gw3ZVPDmsQnS7fonOvzylVJKqoTYhYDF5ym8htX2UBrPL1dWeg8GLAWPLbYX-wLwExWWZoXpxPj_dsBCB_HN_nyFvfuIDNVx0jXBo7O3u_Tri67ACb-aroLAy2XF0RZowJjPN98u0qKXc4unVj3WlPAmmzEVwlGFh36i_Babb7tuAXKMr72i1IlhCCZK1OxBa4ifs08vp6nI6QnmWUJyJJj7fw4bDPMmdoqTILka2fGQ"
            />
            <div className="absolute inset-0 bg-primary/20 mix-blend-multiply pointer-events-none"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-primary/30 to-transparent pointer-events-none"></div>
            <div className="absolute bottom-6 left-6 bg-surface-container-lowest/95 backdrop-blur shadow-xl p-6 rounded-xl max-w-sm border-l-4 border-l-secondary">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 bg-secondary rounded-full animate-pulse"></div>
                <span className="text-label-md font-bold uppercase text-secondary">National Response Active</span>
              </div>
              <p className="text-body-md text-on-surface-variant">
                We provide nationwide coverage with over 150 mobile rapid-response units ready to deploy.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;